import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';

@Component({
  selector: 'morva-active-session-modal',
  templateUrl: './active-session-modal.component.html',
  styleUrl: './active-session-modal.component.scss'
})
export class ActiveSessionModalComponent {
  @Input() message: string = '';
  @Input() title: string = 'خطا';

  constructor(
    private dialogRef: NbDialogRef<ActiveSessionModalComponent>
  ) {}
  
  ngOnInit(): void {}


  close() {
    this.dialogRef.close('cancel');
  }
  
  continue() {
    this.dialogRef.close('continue');
  }
}


